import React, { useState } from 'react';
import { Filter } from 'lucide-react';
import { Button, CardHeader, CardTitle } from '@cargomatic/ui';
import { FilterBar } from './FilterBar';
/**
 * Card header with a title, filter toggle, action buttons, and a collapsible FilterBar.
 *
 * Usage:
 * ```
 * <FilterCardHeader title="Shipments" actions={<BulkActions />} onReset={resetFilters}>
 *   <StatusFilter ... />
 *   <DateRangeFilter ... />
 * </FilterCardHeader>
 * ```
 */
export function FilterCardHeader({ title, actions, onReset, children, defaultOpen = true, className, }) {
    const [showFilters, setShowFilters] = useState(defaultOpen);
    return (React.createElement(CardHeader, { className: className },
        React.createElement("div", { className: "flex items-center justify-between" },
            React.createElement("div", { className: "flex items-center gap-2" },
                React.createElement(CardTitle, { className: "text-lg font-semibold" }, title),
                React.createElement(Button, { variant: showFilters ? 'secondary' : 'ghost', size: "sm", onClick: () => setShowFilters((prev) => !prev), className: "h-8 w-8 p-0", "aria-label": "Toggle filters", "aria-expanded": showFilters },
                    React.createElement(Filter, { className: "size-4" }))),
            actions && React.createElement("div", { className: "flex items-center gap-2" }, actions)),
        showFilters && React.createElement(FilterBar, { onReset: onReset }, children)));
}
